import { useDroppable } from '@dnd-kit/core';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import { encodeInsertId } from '@/components/tree-dnd/tree-dnd-path';
import { useTreeDndDropIndicator } from '@/components/tree-dnd/tree-dnd-context';
import { isDropIndicatorAt } from '@/components/tree-dnd/tree-dnd-drop-indicator';

interface TreeDndSiblingGapProps {
  parentPath: NodePath;
  index: number;
}

export function TreeDndSiblingGap({
  parentPath,
  index,
}: TreeDndSiblingGapProps) {
  const dropIndicator = useTreeDndDropIndicator();
  const isActive = isDropIndicatorAt(dropIndicator, parentPath, index);

  const { setNodeRef } = useDroppable({
    id: encodeInsertId(parentPath, index),
  });

  return (
    <div
      ref={setNodeRef}
      className="flex min-h-4 flex-col items-center justify-center py-1"
    >
      {isActive ? (
        <div className="h-1.5 w-full rounded-full bg-blue-500" />
      ) : null}
    </div>
  );
}
